import type { Messages } from "@prop/i18n";
import type en from "../en/auth";

export default {
  email: "E-mail",
  password: "Пароль",
  passwordHint: "Не меньше 8 символов.",
  displayName: "Имя",
  optional: "необязательно",
  showPassword: "Показать пароль",
  hidePassword: "Скрыть пароль",
  or: "или",
  submit: {
    login: "Войти",
    register: "Создать аккаунт",
    verify: "Подтвердить",
    send: "Отправить ссылку",
    reset: "Сохранить пароль",
  },
  login: {
    title: "Вход",
    noAccount: "Впервые здесь?",
    toRegister: "Создать аккаунт",
    forgot: "Забыли пароль?",
  },
  register: {
    title: "Создание аккаунта",
    subtitle: "Бесплатный аккаунт за минуту: e-mail и пароль или Telegram в одно касание.",
    haveAccount: "Уже зарегистрированы?",
  },
  fieldErrors: {
    email: "Введите e-mail вида name@example.com",
    password: "Не меньше 8 символов",
  },
  telegram: {
    button: "Продолжить через Telegram",
    notConfigured: "Вход через Telegram пока недоступен",
    opening: "Открываем Telegram…",
    waitingTitle: "Подтвердите в Telegram",
    waitingHint: "В @{bot} нажмите «Подтвердить вход». Эта страница войдёт сама.",
    waitingHintStepUp: "В @{bot} нажмите «Подтвердить». Это окно продолжит само.",
    stepOpen: "Откройте бота",
    stepConfirm: "Нажмите «Подтвердить»",
    stepBack: "Вернитесь сюда",
    openAgain: "Открыть Telegram ещё раз",
    openWeb: "Открыть в браузере",
    qr: "Нет Telegram на компьютере? Отсканируйте камерой телефона.",
    cancel: "Отмена",
    expired: "Срок запроса истёк. Начните заново — это секунда.",
    unavailable: "Не удалось начать вход через Telegram. Проверьте соединение и попробуйте ещё раз",
  },
  mfa: {
    title: "Двухэтапная проверка",
    totpLabel: "Код из приложения-аутентификатора",
    useKey: "Войти ключом безопасности или passkey",
    useRecovery: "Ввести резервный код",
    useTotp: "Код из приложения",
    recoveryLabel: "Резервный код",
    keyWaiting: "Следуйте подсказке браузера…",
  },
  forgot: {
    title: "Сброс пароля",
    subtitle: "Мы пришлём ссылку для нового пароля на e-mail.",
    sent: "Если аккаунт с таким e-mail есть, ссылка уже в пути. Проверьте почту.",
  },
  reset: {
    title: "Новый пароль",
    done: "Пароль изменён. Все сессии завершены — войдите снова.",
  },
  verify: {
    optional: "Пока не подтверждён — это необязательно.",
    sendLink: "Отправить ссылку",
    title: "Подтверждение e-mail",
    working: "Подтверждаем…",
    done: "E-mail подтверждён.",
    banner: "Подтвердите e-mail: мы отправили ссылку на {email}.",
    resend: "Отправить ещё раз",
    resent: "Отправлено.",
  },
  toLogin: "Ко входу",
  passwordProblems: {
    too_short: "Слишком короткий: не меньше 8 символов",
    too_long: "Слишком длинный",
    contains_email: "Не должен содержать имя из e-mail",
    too_simple: "Слишком простой: нужно больше разных символов",
  },
} satisfies Messages<typeof en>;
